export type Channel = 'exec' | 'data';

export const composeHandleId = (channel: Channel, io: 'in' | 'out', rawId: string) =>
  `${channel}:${io}:${rawId}`;

export function parseHandleId(id?: string | null): { channel: Channel; io: 'in' | 'out'; raw: string } | null {
  if (!id) return null;
  const [ch, io, raw] = String(id).split(':') as [Channel, 'in' | 'out', string];
  if ((ch !== 'exec' && ch !== 'data') || (io !== 'in' && io !== 'out') || !raw) return null;
  return { channel: ch, io, raw };
}

